(function IIFE() {
    'use strict';

    /////////////////////////////

    function WidgetSettingsAdvancedController(Widget) {
        'ngInject';

        var widgetSettingsAdvanced = this;

        /////////////////////////////
        //                         //
        //    Public attributes    //
        //                         //
        /////////////////////////////

        /////////////////////////////

        /**
         * Services and utilities.
         */
        widgetSettingsAdvanced.Widget = Widget;

        /**
         *
         */
        widgetSettingsAdvanced.restrictToIds = [];

        /////////////////////////////

        /**
         * Set the parent controller.
         *
         * @param {Object} parentCtrl The parent controller.
         */
        this.setParentController = function setParentController(parentCtrl) {
            widgetSettingsAdvanced.parentCtrl = parentCtrl;
        };

        /**
         *
         */
        function onRestrictToChange(restrictToGroups) {
            widgetSettingsAdvanced.restrictToIds = restrictToGroups.map((g) => g.id);

            widgetSettingsAdvanced.Widget.getCurrent().feedKeys = widgetSettingsAdvanced.restrictToIds;
        }

        widgetSettingsAdvanced.onRestrictToChange = onRestrictToChange;
    }

    /////////////////////////////

    function WidgetSettingsAdvancedDirective() {
        'ngInject';

        function link(scope, el, attrs, ctrls) {
            ctrls[0].setParentController(ctrls[1]);
        }

        return {
            bindToController: true,
            controller: WidgetSettingsAdvancedController,
            controllerAs: 'widgetSettingsAdvanced',
            link: link,
            require: ['widgetSettingsAdvanced', '^widgetSettings'],
            restrict: 'E',
            // eslint-disable-next-line max-len
            templateUrl:
                '/client/front-office/modules/content/modules/widget/common/views/widget-settings-advanced.html',
            transclude: true,
        };
    }

    /////////////////////////////

    angular.module('Directives').directive('widgetSettingsAdvanced', WidgetSettingsAdvancedDirective);
})();
